define('vspot-angular/services/org-dashboard-pins-service',[], function () {
    'use strict';

    return ['resources.OrgDashboardPins', function (OrgDashboardPins) {

        return {
            /*
             * Get a list of all the pins for the current user.
             *
             * @param sortType - How the data should be sorted from the server.
             *                  The options sent are the language file key for the
             *                  options shown to the user. i.e. [TBD].
             *
             * @param hidePastEvents - Whether or not to show activities wit no current jobs.
             * @param currentPage - Which page of the result set to show. 1 is the default.
             * @param itemsPerPage - How many items to show on each page of the result set. 10 is the default.
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            query: function() {
                return OrgDashboardPins.query();
            },

            save: function(activity_id) {
                return OrgDashboardPins.save({
                    activity_id:    activity_id,
                    display_order:  0
                });
            },

            delete: function(id) {
                return OrgDashboardPins.delete({
                    id: id
                });
            }
        };
    }];
});

